import { onBeforeUnmount, onMounted, ref } from 'vue'

const readFlag = (key: string) => {
  try {
    return localStorage.getItem(key) === '1'
  } catch {
    return false
  }
}

/**
 * A localStorage '1' flag that toggles an admin testing aid (e.g. the admin bar sets
 * 'perlingo.debug'). Re-read on mount, on cross-tab `storage` events and on
 * `toggleEvent`, which same-tab toggles dispatch.
 */
export function useStorageFlag(key: string, toggleEvent: string, onRead: (value: boolean) => void) {
  const active = ref(readFlag(key))

  const read = () => {
    try {
      active.value = localStorage.getItem(key) === '1'
    } catch {
      /* */
    }
    onRead(active.value)
  }

  /** Clears the flag and tells other players on the page. */
  const clear = () => {
    try {
      localStorage.removeItem(key)
    } catch {
      /* */
    }
    active.value = false
    window.dispatchEvent(new CustomEvent(toggleEvent))
  }

  onMounted(() => {
    read()
    window.addEventListener('storage', read)
    window.addEventListener(toggleEvent, read)
  })
  onBeforeUnmount(() => {
    window.removeEventListener('storage', read)
    window.removeEventListener(toggleEvent, read)
  })

  return { active, read, clear }
}
